/**
 * Where the Automation (the Drop Generator's client name since 12/10/2026)
 * lives in the app: the countries index and one country's page. The old
 * /admin/drop-generator and /admin/automations links redirect here.
 * For Media Devoted | Created By Ciro Autiero
 */

export const AUTOMATION_PATH = '/admin/automation';

/** One country's Automation page, with an optional `?…` query. */
export const automationCountryPath = (countryKey: string, search = ''): string =>
  `${AUTOMATION_PATH}/${countryKey}${search}`;
